import {Partner} from '@soluto-private/mx-context-types';

export const DEFAULT_FALLBACK_PARTNERS = Object.values(Partner);

/**
 * Returns a list of all supported partners.
 * @deprecated Use Object.values(Partner)
 */
export const getSupportedPartners = () => Promise.resolve(DEFAULT_FALLBACK_PARTNERS);
